const qs = require('qs')

export const parseQuery = query => qs.parse(query, {ignoreQueryPrefix: true})
export const stringifyQuery = obj => {
  const stringifiedQuery = qs.stringify(obj, {format: 'RFC1738', arrayFormat: 'repeat'})
  return stringifiedQuery && `?${stringifiedQuery}`
}
